import {Component} from 'react';
import PropTypes from 'prop-types';

import { Radio, FormControlLabel } from '@mui/material';

class BooleanRadio extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.defaultValue,
		};
	}
	onChange(event) {
		this.setState({ value: event.target.value });
	}
	render() {
		// Make sure the radio buttons line out fairly flush with fields & buttons
		// in Installation screen
		const radioButtonStyle = {
			padding: '5px',
		};
		// Used a hidden input since for some reason radio values dont get propagated right
		// or, which is more likely, our formData solution in inspection.js is so broken
		// I cant seem to get it to work with radio buttons. Yay
		// AF 2019-04-07
		return (
			<div
				role="radiogroup"
				aria-label={this.props.label}>
				<input
					name={this.props.name}
					value={this.state.value}
					readOnly={this.props.readOnly}
					data-notrequired={this.props['data-notrequired']}
					type="hidden" />
				<FormControlLabel
					style={{ marginRight: '32px' }}
					control={
						<Radio
							style={radioButtonStyle}
							inputProps={{ 'data-notrequired': this.props['data-notrequired'] || null }}
							aria-label={this.props.name}
							value="1"
							checked={this.state.value === '1'}
							color="primary"
							onChange={this.onChange.bind(this)}
							readOnly={this.props.readOnly}
							disabled={this.props.readOnly}
						/>}
					label={ this.props.t.radiobutton_yes } />
				<FormControlLabel
					style={{ marginRight: '32px' }}
					control={
						<Radio
							style={radioButtonStyle}
							inputProps={{ 'data-notrequired': this.props['data-notrequired'] || null }}
							aria-label={this.props.name}
							value="0"
							checked={this.state.value === '0'}
							color="primary"
							onChange={this.onChange.bind(this)}
							readOnly={this.props.readOnly}
							disabled={this.props.readOnly}
						/>}
					label={ this.props.t.radiobutton_no } />
			</div>
		);
	}
}

BooleanRadio.propTypes = {
	name: PropTypes.string.isRequired,
	defaultValue: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};

export default BooleanRadio;
